module.exports = __webpack_public_path__ + "img/11-twoImg.5262ed06.png";